module.exports = __webpack_public_path__ + "static/media/cerberus_logo.b4c18535.png";